import React, { Component } from 'react';
import { firebase } from './firebase/firebaseconfig'
// import {firebase} from 'firebase'

class LoginWithOutlook extends Component {
    constructor(props) {
        super(props)
        this.state={
           loggedIn:"Success"
        }
    }    

componentDidMount(){
    
    // var FirebaseVal = new firebase.auth
    var provider = new firebase.auth.OAuthProvider('microsoft.com');   
         

    // Initialize the default app
    
    // var admin = require("firebase-admin");

    // var serviceAccount = require("./pcna-c2fc2-firebase-adminsdk-e2baw-50dacfe38b.json");

    // admin.initializeApp({
    // credential: admin.credential.cert(serviceAccount),
    // databaseURL: "https://pcna-c2fc2.firebaseio.com"
    // });
 
    
    // firebase.auth().signInWithRedirect(provider);
    // debugger
    // console.log("Sign In........")   
    // firebase.auth().getRedirectResult()
    // .then(function(result) {
    //     debugger
    //     console.log(firebase.auth.UserCredential)
    //     console.log("Logged IN successfully")
                    
    // })
    // .catch(function(error) {
    //     debugger
    //     console.log("Logged IN failed")
    //     console.log(error)
    //     // Handle error.
    // });
    // var provider = new firebase.auth.OAuthProvider('microsoft.com');
    firebase.auth().signInWithPopup(provider)
    .then(function(result) {
        
        this.props.history.push("/home")
      console.log("Signed in")
    })
    .catch(function(error) {
        
        console.log("Error..........")
        console.log(error)
      // Handle error.
    });

}
    render(){
        
        return(
            <div></div>
        )
    }
  }
  export default LoginWithOutlook;

